<template>
  <div style="margin-top: 10px">
    <div class="search-form">
      <el-input
        v-model="config.vendorName"
        placeholder="请输入企业名称"
        style="width: 200px"
        class="input-with-select">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div>
    <el-table
      v-loading="loading"
      border
      highlight-current-row
      :data="list"
      @current-change="handleCurrentRowChange">
      <el-table-column
        label=""
        width="50">
        <template slot-scope="{row}">
          <el-radio
            :value="current.vendorId"
            :label="row.vendorId">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column
        label="企业名称"
        prop="vendorName">
      </el-table-column>
      <el-table-column
        label="联系人"
        prop="vendorPerson"
        width="120"
      ></el-table-column>
    </el-table>
    <el-pagination
      background
      style="text-align: center;"
      :current-page="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="totalNum"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'VendorSelectTable',
  components: {},
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      list: [],
      config: {
        pageNum: 1,
        pageSize: 10,
        vendorName: ''
      },
      totalNum: 0,
      current: {}
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  methods: {
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    handleCurrentRowChange(row) {
      this.current = row || {}
    },
    reset() {
      this.list = []
      this.config.pageNum = 1
      this.config.vendorName = ''
      this.current = {}
      this.totalNum = 0
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('account/getvendors', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
